import React from "react";
import PropTypes from "prop-types";
import i18n from "~/i18n";
import { ActionObjectDialog } from "../ActionObjectDialog/ActionObjectDialog.jsx";

export const DuplicateObjectDialog = ({
  name,
  open,
  title,
  labelText,
  explainerText,
  onSubmit,
  onCancel,
  submitButtonText,
  limit,
}) => {
  return (
    <ActionObjectDialog
      name={name}
      open={open}
      title={title}
      labelText={labelText}
      explainerText={explainerText}
      submitButtonText={submitButtonText}
      onSubmit={onSubmit}
      onCancel={onCancel}
      limit={limit}
    />
  );
};

DuplicateObjectDialog.propTypes = {
  name: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.string,
  labelText: PropTypes.string,
  explainerText: PropTypes.string,
  submitButtonText: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  limit: PropTypes.number,
};

DuplicateObjectDialog.defaultProps = {
  name: "",
  open: false,
  title: i18n.t("Duplicate"),
  labelText: i18n.t("New object name"),
  submitButtonText: i18n.t("Duplicate"),
  explainerText: "",
};
